import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 38BFE155-0352-4907-A578-B5D0D7F5B78D
 * name check-outline
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/check-outline.svg
 * tags
 */
export const CheckOutlineIcon = createSvgIcon(<><path d="M19.78,2.2L24,6.42L8.44,22L0,13.55L4.22,9.33L8.44,13.55L19.78,2.2M19.78,5L8.44,16.36L4.22,12.19L2.81,13.55L8.44,19.17L21.19,6.42L19.78,5Z" /></>, 'CheckOutlineIcon');
export default CheckOutlineIcon